module.exports = __webpack_public_path__ + "img/52.be97cd8f.svg";